import { Navigate } from 'react-router-dom'
import { SITE_ADMIN_COURSE_EDITOR_ROOT, SITE_ADMIN_ROOT, SITE_USER_ROOT } from 'config'
import { useAuth } from 'react-oidc-context'
import useUserRole from 'hooks/useUserRole'
import { getEntryPath } from 'store/authentication/utils'
import { useEffect } from 'react'
import OverlayLoader from 'components/ui/OverlayLoader'

export default function Login(): JSX.Element {
  const auth = useAuth()
  const { isAdmin, isGpsEditor, isAdminCourseEditor } = useUserRole()

  useEffect(() => {
    const checkAuth = async () => {
      if (!auth.isAuthenticated && !auth.isLoading) {
        await auth.signinRedirect()
      }
    }
    checkAuth()
  }, [auth.isAuthenticated, auth.isLoading])

  if (auth.isLoading || !auth.isAuthenticated) {
    return <OverlayLoader visible={true} />
  }

  if (isGpsEditor) {
    const userRoute = getEntryPath() !== '' ? getEntryPath() : SITE_USER_ROOT
    return <Navigate to={userRoute} />
  }

  if (!isAdmin && !isAdminCourseEditor) {
    auth.signinRedirect()
  }

  const getAdminRoute = () => {
    if (isAdmin) {
      return getEntryPath() !== '' ? getEntryPath() : SITE_ADMIN_ROOT
    }
    return getEntryPath() !== '' ? getEntryPath() : SITE_ADMIN_COURSE_EDITOR_ROOT
  }

  return <Navigate to={getAdminRoute()} />
}
